module.exports = __webpack_public_path__ + "img/palisade-25.7a613a66.png";